// extracted by mini-css-extract-plugin
export var actions = "_1b-0";
export var actionsContainer = "_1b-7";
export var border = "_1b-1";
export var childFullHeight = "_1b-g";
export var collapse = "_1b-2";
export var content = "_1b-b";
export var contentChild = "_1b-f";
export var fullscreen = "_1b-d";
export var hasLeftRadius = "_1b-l";
export var headerContainer = "_1b-3";
export var headerRow = "_1b-5";
export var hidePadding = "_1b-c";
export var navCollapsedGap = "_1b-m";
export var noScrollX = "_1b-n";
export var noScrollY = "_1b-o";
export var noTopPadding = "_1b-j";
export var optOutTopPadding = "_1b-e";
export var pageMain = "_1b-k";
export var pageOuter = "_1b-h";
export var pagePadding = "_1b-8";
export var pageScroll = "_1b-9";
export var profile = "_1b-p";
export var profileContainer = "_1b-q";
export var profileImage = "_1b-r";
export var profileMain = "_1b-s";
export var profileSubtitle = "_1b-u";
export var profileTitle = "_1b-t";
export var settingsSurface = "_1b-a";
export var showLeftPadding = "_1b-i";
export var tabsPortalSlot = "_1b-6";
export var tabsWrapper = "_1b-4";
export var title = "_1b-v";